
import React from 'react';
import BaseChart from './common/BaseChart';
import BarChartComponent from './common/BarChartComponent';
import ChartSkeleton from '../common/ChartSkeleton';

interface DailyActivityChartProps {
  dailyStats: any[];
  loading: boolean;
  exportCSV: (data: any[], filename: string) => void;
}

const DailyActivityChart = React.memo(({ 
  dailyStats, 
  loading, 
  exportCSV 
}: DailyActivityChartProps) => {
  const processedData = React.useMemo(() => {
    return dailyStats.map(item => ({
      ...item,
      short_date: new Date(item.date).toLocaleDateString('en-US', { 
        month: 'short', 
        day: 'numeric' 
      })
    }));
  }, [dailyStats]);

  if (loading) {
    return (
      <ChartSkeleton 
        title="Daily Activity"
        description="Activity distribution across days"
        height={400}
        type="bar"
      />
    );
  }

  return (
    <BaseChart
      title="Daily Activity"
      description="Activity distribution across days"
      data={processedData}
      loading={false}
      exportCSV={exportCSV}
      exportFilename="daily_stats"
      chartType="bar"
    >
      <BarChartComponent
        data={processedData}
        dataKey="count"
        nameKey="short_date"
        color="#8b5cf6"
        formatter={(value) => [`${value}`, 'Events']}
        angle={-45}
        margin={{ top: 20, right: 30, left: 20, bottom: 70 }}
        enableMultilineLabels={false}
      />
    </BaseChart>
  );
});

DailyActivityChart.displayName = 'DailyActivityChart';

export default DailyActivityChart;
